module.exports = __webpack_public_path__ + "static/media/red_giant.82b4bc71.png";